import { render, staticRenderFns } from "./DrawerNestedMenuItems.html?vue&type=template&id=722ca82d&scoped=true&"
import script from "./DrawerNestedMenuItems.js?vue&type=script&lang=js&"
export * from "./DrawerNestedMenuItems.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ca82d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListGroup,VListItem,VListItemContent,VListItemTitle})
